import * as Yup from 'yup';

const Validation = Yup.object({
    plan_name: Yup.string().required("Required"),
    storage_size: Yup.number().required("Required"),
    price: Yup.number().required("Required"),
    duration: Yup.number().required("Required"),
    price_id: Yup.string().required("Required"),
    product_id: Yup.string().required("Required"),
    description: Yup.string().required("Required"),
    status: Yup.string().required("Required"),

});

export default Validation;
